
import { AppService } from "app/services/app.service";

import { ConfigParking } from "app/pages/full-pages/estacionamento/add-parking-integration/add-parking-integration.component";
import { Observable } from "rxjs";

export abstract class AbParking extends AppService {

  abstract salvar(configParking: ConfigParking): Observable<any>;
  abstract obterConfigParkingCadastrado()
  abstract obterCredenciados(url: string, queryParams: any);
  abstract obterAssinaturas(urlToLoadSignatures: string, queryParams: any);
}